module.exports = __webpack_public_path__ + "media/src/images/example_voucher_card_de-88560bb2619b876112b7f47576a20a0c.jpg";